import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import DesktopMenu from './menu';

export const renderDesktopNav = () => {
  const desktopNavTarget = document.querySelector(`[react-render-target="desktop-nav"]`);
  if (desktopNavTarget) {
    ReactDOM.render(
      <StrictMode>
        <DesktopMenu />
      </StrictMode>,
      desktopNavTarget
    );
  }
};
